/**
 * Shared HSE/KS tab bar — chemical-inventory / RiskSubnav visual.
 * Use for risk, events, documents, settings. Do not invent a second tab style.
 */
export function HseTabBar({
  tabs = [],
  activeId,
  onSelect,
  ariaLabel,
  trailing,
  wrap = false,
}) {
  return (
    <div className="mb-6 bg-white shadow sm:rounded-lg">
      <div className="border-b border-gray-200 px-4 py-3 sm:px-6">
        <div className="flex items-center justify-between gap-4">
          <nav
            className={
              wrap
                ? "flex flex-wrap gap-x-4 gap-y-1"
                : "flex space-x-4 overflow-x-auto"
            }
            aria-label={ariaLabel}
          >
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeId === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => onSelect?.(tab)}
                  className={`inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium ${
                    isActive
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`}
                >
                  {Icon ? <Icon className="h-4 w-4 shrink-0" /> : null}
                  {tab.label}
                </button>
              );
            })}
          </nav>
          {trailing ? <div className="shrink-0">{trailing}</div> : null}
        </div>
      </div>
    </div>
  );
}
